import SocketClient, { SocketType } from '@/utils/socketClient';

const WebsocketInstance = (url: string, type: SocketType) => new SocketClient(url, type, (data: any) => data);

export default WebsocketInstance;
